import { Components } from '@mui/material/styles'

export const MuiContainerOverrides: Components['MuiContainer'] = {
  styleOverrides: {
    root: {
      paddingLeft: 2, // 16px (2 * 8px)
      paddingRight: 2, // 16px (2 * 8px)
    },
  },
}
